var _rect, _rect2, _path, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendHeaderExp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 322,
    viewBox: "0 0 304 322",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.09375,
    width: 110.688,
    height: 96.2227,
    rx: 3.77344,
    fill: "#7BD6E7",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 195,
    width: 108,
    height: 29,
    rx: 3.77344,
    fill: "#007C6D",
    fillOpacity: 0.32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 25.7852C36 21.6171 39.3789 18.2383 43.5469 18.2383H258.004C262.172 18.2383 265.551 21.6171 265.551 25.7852V314.453C265.551 318.621 262.172 322 258.004 322H43.5469C39.3789 322 36 318.621 36 314.453V25.7852Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 15.5,
    width: 119,
    height: 212,
    rx: 7.04688,
    stroke: "#016479"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 150.775,
    y1: 18.2383,
    x2: 151.09,
    y2: 290.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6416A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4800BD",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendHeaderExp);
export default __webpack_public_path__ + "static/media/pend-header-exp.9a6b3cecff7a2eebf0e101ea319f959c.svg";
export { ForwardRef as ReactComponent };